import { Observable } from 'rxjs';
import { ofType } from 'redux-observable';
import { concatMap } from 'rxjs/operators';
import { Action } from 'redux';
import { UpdateRelationSplit, UpdateRecordLabelRelation } from '../action-creators';
import { UPDATE_RECORD_LABEL_RELATION_SPLIT } from '../actions';
import { keyDebounceTime } from '../../operators';

export const autosaveRelationEpic = (action$: Observable<Action>) =>
  action$.pipe(
    ofType<Action, UpdateRelationSplit>(UPDATE_RECORD_LABEL_RELATION_SPLIT),
    keyDebounceTime(2000, (action) => `${action.relation.recordLabelId}-${action.relation.artistId}`),
    concatMap((actions) => {
      return actions.map((action) => new UpdateRecordLabelRelation({
        ...action.relation,
        split: action.split
      }));
    })
  );